import { UsersThree, User, Briefcase, Barbell, BoxingGlove, Users } from "@phosphor-icons/react";
import { useInView, useTilt } from "@/hooks/useInView";

const offers = [
  {
    icon: User,
    key: "private",
    bookUrl: "/apply?type=coaching",
    title: "Private Coaching",
    price: "Starting at $125/session",
    desc: "One-on-one coaching built around the individual. Sessions may include striking fundamentals, self-defense, strength and conditioning, situational awareness, confidence development, and composure under pressure. Every program is adapted to the client's experience, needs, and goals.",
    cta: "Apply for Coaching",
  },
  {
    icon: UsersThree,
    key: "youth",
    bookUrl: "/apply?type=youth",
    title: "3SM Youth Readiness\u2122",
    price: "Starting at $125/session",
    desc: "Confidence, discipline, coordination, situational awareness, personal boundaries, and age-appropriate self-defense for children and teens. The goal is not to make young people aggressive \u2014 it's to help them become more aware, composed, and responsible at school, at home, and in their communities.",
    cta: "Enroll Your Child",
  },
  {
    icon: UsersThree,
    key: "workshop",
    bookUrl: "/apply?type=workshop",
    title: "Self-Defense Workshops",
    price: "Starting at $49/person",
    desc: "Trauma-informed sessions for women's groups, co-ed classes, and community programs. Build situational awareness, boundary-setting, and practical physical confidence in a structured, supportive environment.",
    cta: "Request a Workshop",
  },
  {
    icon: Users,
    key: "org",
    bookUrl: "/apply?type=workshop",
    title: "Organizational & Community Workshops",
    price: "Custom pricing",
    desc: "Interactive workshops and ongoing programming for schools, nonprofits, youth organizations, women's groups, and community programs. Small private groups to workshops of 40+ participants.",
    cta: "Bring 3SM to Your Group",
  },
  {
    icon: Briefcase,
    key: "corporate",
    bookUrl: "/apply?type=workshop",
    title: "Corporate Self-Defense Workshops",
    price: "Custom proposals",
    desc: "Team-focused self-defense and situational awareness training for businesses and gyms. Improve team resilience, communication, and personal-safety confidence in a professional setting.",
    cta: "Request a Proposal",
  },
  {
    icon: Briefcase,
    key: "executive",
    bookUrl: "/apply?type=executive",
    title: "3SM Executive Composure\u2122",
    price: "Custom proposals from $129/person",
    desc: "A professional-development experience for leaders, professionals, and teams. Navigate pressure, conflict, workplace misconduct, and difficult communication with regulated presence, strategic thinking, clear boundaries, and career-protective decision-making.",
    cta: "Submit an Inquiry",
  },
  {
    icon: Users,
    key: "smallgroup",
    bookUrl: "/apply?type=workshop",
    title: "Small-Group Training",
    price: "Starting at $35/session",
    desc: "Focused training for pairs and small groups. Progressive striking, self-defense, and conditioning designed for consistent development and shared accountability.",
    cta: "Join a Small Group",
  },
  {
    icon: BoxingGlove,
    key: "striking",
    bookUrl: "/apply?type=coaching",
    title: "Striking & Boxing Instruction",
    price: "Starting at $125/session",
    desc: "Technical striking and boxing coaching from a former professional MMA fighter. Fundamentals, footwork, defense, and combinations \u2014 built for beginners through experienced practitioners.",
    cta: "Book a Session",
  },
  {
    icon: Barbell,
    key: "strength",
    bookUrl: "/apply?type=coaching",
    title: "Strength & Conditioning",
    price: "Starting at $125/session",
    desc: "Programming that builds physical capability, discipline, resilience, and trust in your body. Integrated with striking and self-defense when it fits the goal.",
    cta: "Start Training",
  },
];

export default function OffersSection() {
  const [ref, inView] = useInView();
  const goBook = (o) => window.location.href = o.bookUrl;

  return (
    <section id="offers" data-testid="offers-section" className="bg-[#111111] py-16 sm:py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4 reveal ${inView ? 'visible' : ''}`}>Programs</p>
        <h2 className={`font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-10 max-w-lg reveal ${inView ? 'visible' : ''} stagger-1`}>
          Find your path.
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {offers.map((o, i) => (
            <TiltCard key={o.title} o={o} i={i} inView={inView} goBook={goBook} />
          ))}
        </div>
      </div>
    </section>
  );
}


function TiltCard({ o, i, inView, goBook }) {
  const tiltRef = useTilt(6);

  return (
    <div
      ref={tiltRef}
      data-testid={`offer-card-${o.title.toLowerCase().replace(/\s+/g, '-')}`}
      className={`tilt-card glass-card border border-white/10 p-8 rounded-lg hover:border-[#D4AF37]/40 group shimmer-border reveal-scale ${inView ? 'visible' : ''} stagger-${i + 1}`}
    >
      <div className="animate-float">
        <o.icon size={32} weight="duotone" className="text-[#D4AF37] mb-6 group-hover:scale-110 transition-transform" />
      </div>
      <h3 className="font-heading text-xl font-semibold text-[#F2EFE9] mb-1">{o.title}</h3>
      {o.price && <p className="text-xs text-[#D4AF37]/80 font-body font-semibold mb-3">{o.price}</p>}
      <p className="text-sm text-[#8C8C8C] font-body leading-relaxed mb-6">{o.desc}</p>
      <button
        onClick={() => goBook(o)}
        data-testid={`offer-cta-${o.title.toLowerCase().replace(/\s+/g, '-')}`}
        className="text-[#D4AF37] text-sm font-bold tracking-wider uppercase hover:text-[#E5C158] transition-colors group-hover:tracking-[0.2em]"
      >
        {o.cta} &rarr;
      </button>
    </div>
  );
}
